import { FileMetadata } from "@jace/api";
import { clamp } from "@zetalabs/core";
import { create } from "zustand";
import { FilePreviewModal } from "./file-preview-modal";

type State = {
	isOpen: boolean;
	data: FileMetadata | undefined;
	current: number;
	total: number;
	files: FileMetadata[];
	loop: boolean;
};

type Actions = {
	open: (start: number, files: FileMetadata[]) => void;
	close: () => void;
	next: () => void;
	prev: () => void;
};

type Store = State & Actions;

function next(current: number, total: number, loop?: boolean) {
	if (loop) {
		return (current + 1) % total;
	}

	return clamp(current + 1, 0, total);
}

function prev(current: number, total: number, loop?: boolean) {
	if (loop) {
		return (current - 1 + total) % total;
	}

	return clamp(current - 1, 0, total);
}

export const useFilePreviewStore = create<Store>((set) => ({
	data: undefined,
	isOpen: false,
	loop: false,
	current: 0,
	total: 0,
	files: [],
	open: (start, files) =>
		set(() => {
			{
				const nStart = clamp(start, 0, files.length);

				return {
					files,
					current: nStart,
					data: files[nStart],
					total: files.length - 1,
					isOpen: true,
				};
			}
		}),
	close: () => set({ files: [], isOpen: false }),
	next: () =>
		set((state) => {
			const nextIndex = next(state.current, state.total, state.loop);

			return {
				current: nextIndex,
				data: state.files[nextIndex],
			};
		}),
	prev: () =>
		set((state) => {
			const prevIndex = prev(state.current, state.total, state.loop);
			return { current: prevIndex, data: state.files[prevIndex] };
		}),
}));

export function FilePreviewer() {
	const { files } = useFilePreviewStore();

	if (files.length === 0) {
		return null;
	}

	return <FilePreviewModal />;
}
